import type { Profile } from "../types";
import type { AccountSession } from "../auth";
import type { SyncStatus } from "../useAccountSync";
import { Icon } from "./Icon";

interface AppHeaderProps {
  profile: Profile;
  planner?: boolean;
  tripName?: string;
  onHome: () => void;
  onProfile: () => void;
  account: AccountSession | null;
  accountPending: boolean;
  syncStatus: SyncStatus;
  onAccount: () => void;
  onEditTrip?: () => void;
}

export function AppHeader({
  profile,
  planner = false,
  tripName,
  onHome,
  onProfile,
  account,
  accountPending,
  syncStatus,
  onAccount,
  onEditTrip,
}: AppHeaderProps) {
  return (
    <header className="app-header">
      <button className="brand brand-button" type="button" onClick={onHome} aria-label="Open all trips">
        <span className="brand-route"><Icon name="route" size={20} /></span>
        <span className="brand-name">roam</span>
      </button>

      <div className="header-context" aria-label={planner ? "Current trip" : "Current section"}>
        {planner ? (
          <>
            <button className="header-path" type="button" onClick={onHome} aria-label="Back to trips">
              Trips
            </button>
            <Icon name="arrow-right" size={14} />
            <strong aria-current="page">{tripName}</strong>
          </>
        ) : <strong aria-current="page">Trips</strong>}
      </div>

      <div className="header-actions">
        {onEditTrip ? (
          <button className="button button-quiet header-edit" type="button" onClick={onEditTrip}>
            <Icon name="edit" /> Edit trip
          </button>
        ) : null}
        <button className={`account-button account-${syncStatus}`} type="button" onClick={onAccount} aria-label={account ? "Open account settings" : "Sign in to Roam"}>
          <Icon name={account ? "cloud" : "login"} size={17} />
          <span>{accountPending ? "Checking…" : account ? (syncStatus === "ready" ? "Synced" : syncStatus === "saving" ? "Saving…" : "Account") : "Sign in"}</span>
        </button>
        {account && !accountPending ? (
          <button className="profile-button" type="button" onClick={onProfile} aria-label="Edit travel profile">
            <span className="profile-initial">{profile.name.trim().charAt(0).toUpperCase() || "R"}</span>
            <span className="profile-copy"><strong>{profile.name || "Traveler"}</strong><small>{profile.homeCity || "Set home city"}</small></span>
            <Icon name="chevron-down" size={15} />
          </button>
        ) : null}
      </div>
    </header>
  );
}
